export const formatLocalTime = (isoDateString: string | Date | undefined): string => {

  if (!isoDateString) return "";
  const date = new Date(isoDateString);
  if (isNaN(date.getTime())) return "";

  const localString = date.toLocaleString('en-US', {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    hour12: false
  });

  return localString.replace(',', '').replace(/\//g, '-');
};

export const formatLocalDate = (isoDateString: string | Date | undefined): string => {
  if (!isoDateString) return "";
  
  const date = new Date(isoDateString);
  
  if (isNaN(date.getTime())) return "";

  const localString = date.toLocaleDateString('en-US', {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
  });

  return localString.replace(/\//g, '-');
};